import { Injectable, signal } from '@angular/core';
import { Element } from '../../equipment/models/elements/element';
import { EquipmentElements } from '../../equipment/models/elements/equipmentElements';
import { Equipment } from '../../equipment/models/equipment';
import { EquipmentBase } from '../models/equipment-base';

@Injectable()
export class PlanogramModes {

	private readonly _imagesMode = signal<boolean>(true);
	private readonly _drawBlockMode = signal<boolean>(false);
	private readonly _equipmentEditMode = signal<boolean>(false);
	private readonly _sequenceNumberMode = signal<boolean>(false);
	private readonly _sizesMode = signal<boolean>(false);
	private readonly _transparentBoxesMode = signal<boolean>(false);
	private readonly _barriersMode = signal<boolean>(true);
	private readonly _flipMode = signal<boolean>(false);
	private readonly _layoutRulesLocked = signal<boolean>(false);

	public readonly imagesMode = this._imagesMode.asReadonly();
	public readonly drawBlockMode = this._drawBlockMode.asReadonly();
	public readonly equipmentEditMode = this._equipmentEditMode.asReadonly();
	public readonly sequenceNumberMode = this._sequenceNumberMode.asReadonly();
	public readonly sizesMode = this._sizesMode.asReadonly();
	public readonly transparentBoxesMode = this._transparentBoxesMode.asReadonly();
	public readonly barriersMode = this._barriersMode.asReadonly();
	public readonly flipMode = this._flipMode.asReadonly();
	public readonly layoutRulesLocked = this._layoutRulesLocked.asReadonly();

	get flipIcon(): string {
		return this._flipMode() ? 'flipFront' : 'flipBack';
	}

	get flipTooltip(): string {
		return this._flipMode() ? 'COMMON.FLIP_FRONT' : 'COMMON.FLIP_BACK';
	}

	public toggleImagesMode() {
		this._imagesMode.set(!this._imagesMode());
	}

	public setImagesMode(value: boolean) {
		this._imagesMode.set(value);
	}

	public toggleDrawBlockMode() {
		this._drawBlockMode.set(!this._drawBlockMode());
	}

	public setDrawBlockMode(value: boolean) {
		this._drawBlockMode.set(value);
	}

	public toggleEquipmentEditMode() {
		this._equipmentEditMode.set(!this._equipmentEditMode());
	}

	public setEquipmentEditMode(value: boolean) {
		this._equipmentEditMode.set(value);
	}

	public toggleSequenceNumberMode() {
		this._sequenceNumberMode.set(!this._sequenceNumberMode());
	}

	public setSequenceNumberMode(value: boolean) {
		this._sequenceNumberMode.set(value);
	}

	public toggleSizesMode() {
		this._sizesMode.set(!this._sizesMode());
	}

	public setSizesMode(value: boolean) {
		this._sizesMode.set(value);
	}

	public toggleTransparentBoxesMode() {
		this._transparentBoxesMode.set(!this._transparentBoxesMode());
	}

	public setTransparentBoxesMode(value: boolean) {
		this._transparentBoxesMode.set(value);
	}

	public toggleBarriersMode() {
		this._barriersMode.set(!this._barriersMode());
	}

	public setBarriersMode(value: boolean) {
		this._barriersMode.set(value);
	}

	public toggleFlipMode() {
		this._flipMode.set(!this._flipMode());
	}

	public setLayoutRulesLocked(value: boolean) {
		this._layoutRulesLocked.set(value);
	}
}